import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Share links and the editor backend often use `/edit/:id` at the origin root.
 * The CRM app mounts the PDF editor at `/dashboard/document-editing/edit/:id`.
 * This guard forwards deep links and keeps query params (e.g. `share=`).
 */
export const documentEditorDeeplinkRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const id = route.paramMap.get('id')?.trim();
  if (!id) {
    return router.parseUrl('/dashboard/home');
  }
  if (String(route.queryParamMap.get('share') ?? '').trim()) {
    return true;
  }
  return router.createUrlTree(['/dashboard', 'document-editing', 'edit', id], {
    queryParams: route.queryParams,
    fragment: route.fragment ?? undefined,
  });
};
